import React, { Component } from 'react';

import { usePromiseTracker } from "react-promise-tracker";
import Loader from "react-loader-spinner";
import "./promiseSpinner.css";
import { FerrisWheelSpinner } from 'react-spinner-overlay';

export default function PromiseSpinner (props) {

const { promiseInProgress } = usePromiseTracker(); 

  return (
    <span>
    {
      promiseInProgress && (
        <div className="spinner">
          <Loader type="ThreeDots" color="#6ec6ec" height="30" width="100"  />
        </div>
        /*<FerrisWheelSpinner loading={true}　color="#FF7626" />*/
      )
    }
  </span>
  );
};